import type { UseI18nOptions } from "vue-i18n"
import type { MessageSchema } from "@/i18n"
import { useI18n } from "vue-i18n"

type PathToLeaves<T, C extends string = ""> = T extends PropertyKey
  ? C
  : {
      [P in keyof T]: P extends string
        ? C extends ""
          ? PathToLeaves<T[P], `${P}`>
          : PathToLeaves<T[P], `${C}.${P}`>
        : never
    }[keyof T]

export type TranslationPaths = PathToLeaves<MessageSchema>

export function useTranslation(options: UseI18nOptions<{ message: MessageSchema }> = {}) {
  const mergedOptions: UseI18nOptions<{ message: MessageSchema }> = {
    useScope: "global",
    ...options,
  }

  return useI18n(mergedOptions)
}
